
import React from 'react'
import { Grid } from '@mui/material'
import {Audience, Talent , Milestone} from '../../assets/img'
import './about.scss'

function Index() {

    const Scroll = () => window.scrollTo({behavior : 'smooth' , top : 0})

    return (
        <div className='about'>
            <div className='jumbotron' style={{backgroundImage : `url(${Talent})`}}>
                <h3 className='title'>ABOUT US</h3>
            </div>

            <div className='info'>
                <p className='content'>With our method, the value and skill development of the participants can be directly seen and evaluated especially during the Showcasing session where the output of the training can be seen by executive level,
                        making the series of training that we provide help to the benefit of the business process in the future.
                </p>

                <div className='information'>
                    <p className='intro'>Dojo Intro</p>
                    <h3 className='title'>The Objectives</h3>
                    
                    <Grid container className='wrapper' >
                        <Grid item md={4} lg={4} className='column-1'>
                            <p className='body'>Providing relevant cases and assisting training participants in resolving business problems.</p>
                        </Grid>

                        <Grid item md={4} lg={4} className='column-2'>
                            <p className='body'>Comprehensive understanding of the fundamentals and value of data to provide a strong and relevant insight to a prospective business partner.</p>
                        </Grid>

                        <Grid item md={4} lg={4} className='column-3'>
                            <p className='body'>Improving business and analytical thinking to help strategic and operational decision-making processes 
                                on a day-to-day basis.
                            </p>
                        </Grid>
                    </Grid>
                </div>
            </div>

            
            <div className='journey'>
                <h3 className='title'>Our Journey</h3>
                <p className='body'>By joining with Dattabot Dojo, we will facilitate your journey in becoming a business leader with a deep understanding of the value of data and improving analytical thinking to create data-driven decision
                    making and insights, not only for subordinates but for future business partners as well. </p>

                <div className='milestone'>
                    <div className='wrapper'>
                        <img src={Milestone}  alt="" />
                    </div>
                </div>
            </div>


            <div className='audience' style={{backgroundImage : `url(${Audience})`}}>
                    <div className='info-audience'>
                        <h3 className='title'>Target Audience</h3>

                        <h3 className='target'>Target Role</h3>
                        <p className='body'>Marketing, Sales, Finance, Planning and Transformation, CEO’s Office, Legal, Human Capital, etc</p>
                        
                        <h3 className='target'>Target Audience</h3>
                        <p className='body'>C- level or Executive, Supporting Functions in Organizations</p>
                    </div>
                </div>

                <span className='back' onClick={Scroll}>Kembali Ke Atas</span>
        </div>
    )
}

export default Index
